export default {
  region: 'Región',
  calling: 'Llamadas',
  logout: 'Cerrar sesión',
  version: 'Versión',
  settings: 'Configuración',
  clickToDial: 'Haga clic para marcar',
  autoCreateLog: 'Crear registro de llamadas automáticamente',
  clickToSMS: 'Haga clic para enviar SMS',
  clickToDialSMS: 'Haga clic para marcar/enviar SMS',
};

